import { DataType } from '@common/enums/data-type';
import { KnownPropertyTypes } from '@common/enums/known-property-types';
import { ObjectTypes } from '@src/suite/common/enums/object-types';
import { IGenericAccessor } from '@src/suite/common/interfaces/i-generic-accessor';

const metaData = {
    Guid: DataType.STRING,
    Type: DataType.NUMBER,
    Title: DataType.STRING,
    WireId: DataType.STRING,
    WireType: DataType.NUMBER,
    FeedId: DataType.STRING,
    Content: DataType.STRING,
    Published: DataType.DISCOVERDATE,
    UpdatedModified: DataType.DISCOVERDATE,
    CreatedDate: DataType.DISCOVERDATE,
    IngestedDate: DataType.DISCOVERDATE,
    Category: DataType.STRING,
    WordCount: DataType.NUMBER,
    TopicId: DataType.STRING,
    Properties: DataType.OBJECT,
    NitfEntity: DataType.OBJECT,
    SrcLink: DataType.STRING,
};

KnownPropertyTypes.setFor(metaData);

export class WireServiceRecord implements IGenericAccessor {
    public Type: number;
    public Guid: string;
    public WireId: string;
    public WireType: number;
    public FeedId: string;
    public Title: string;
    public Content: string;
    public Published: Date;
    public UpdatedModified: Date;
    public CreatedDate: Date;
    public IngestedDate: Date;
    public Category: string;
    public WordCount: number;
    public TopicId: string;
    public Properties: { [key: string]: string };
    public NitfEntity: { [key: string]: string };
    public SrcLink: string;

    private static capitalizeFirstLetter(key: string): string {
        if (!key) return key;
        return key.charAt(0).toUpperCase() + key.slice(1);
    }

    public getMetaData(): { [id: string]: number } {
        const objectKeys = Object.keys(this);
        const ret = {};
        for (const prop of objectKeys) {
            if (metaData[prop]) ret[prop] = metaData[prop];
        }
        return ret;
    }

    public getRawValue(field: string): any {
        if (this.getMetaData()[field]) {
            return this[field];
        }
        return null;
    }

    public static instance(data: any): WireServiceRecord {
        const ret: WireServiceRecord = new WireServiceRecord();
        ret.Type = ObjectTypes.DISCOVER_WIRE;
        ret.Guid = data.wireId;
        for (const key in data) {
            ret[WireServiceRecord.capitalizeFirstLetter(key)] = data[key];
        }
        return ret;
    }
}
